import React from "react";
import { Link } from "react-router-dom";
import "../styles/CarCard.css";

const CarCard = ({ car, brand }) => {
  if (!car) return null;

  return (
    <div className="car-card">
      <Link to={`/brand/${brand}/${car.id || ""}`} className="card-link">
        <img
          src={car.image || "https://via.placeholder.com/280x180?text=No+Image"}
          alt={car.name || "Car"}
          className="car-image"
        />
        <div className="car-info">
          <h3>{car.name || "Unknown Car"}</h3>
          <p className="price">{car.price || "Price on Request"}</p>
          <p className="details">
            {car.km || "N/A"} • {car.fuel || "N/A"} • {car.transmission || "N/A"}
          </p>
          <p className="location">{car.location || "Unknown Location"}</p>
        </div>
      </Link>
    </div>
  );
};

export default CarCard;
